var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('NavBar',{attrs:{"environmentMenuBar":_vm.environmentMenuBar}})],1),_c('main',{attrs:{"role":"main"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }